import { axiosConsumer } from "../consumer/axios-consumer";

const resource = '/api/users';

const apiFindAllActiveUsers = async ()=> new Promise((resolve, reject)=> axiosConsumer().get(`${resource}/`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

const apiFindUserById = async (id)=> new Promise((resolve, reject)=> axiosConsumer().get(`${resource}/${id}`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

const apiUpdateUser = async (req)=> new Promise((resolve, reject)=> axiosConsumer().patch(`${resource}/edit`, req)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

export const UserRepository = {
  findAll: apiFindAllActiveUsers,
  findById: apiFindUserById,
  update: apiUpdateUser
};